export class ResetState {
    public static readonly type = '[MessagingState] Reset messaging state';
}
